import { HttpClient } from '@adapters/HttpClient';
import { OrderPreparationModel } from '../models/OrderPreparation';

export interface OrderPreparationFilters {
  searchTerm?: string;
  status_ids?: number[];
  location_ids?: number[];
  courier_ids?: string;
  team_id?: number;
  sortBy?: 'id' | 'created_at' | 'updated_at';
  sortDirection?: 'asc' | 'desc';
  page?: number;
  limit?: number;
  // Advanced filters
  filters?: Array<{
    column: string;
    operator: string;
    value?: any;
  }>;
  logic?: string;
}

export interface OrderPreparationPage {
  orderpreparation: OrderPreparationModel[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class OrderPreparationApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getOrderPreparationPaginated(filters: OrderPreparationFilters = {}): Promise<OrderPreparationPage> {
    const {
      searchTerm = '',
      status_ids,
      location_ids,
      courier_ids,
      team_id,
      sortBy = 'id',
      sortDirection = 'desc',
      page = 1,
      limit = 15,
      filters: advancedFilters,
      logic = 'AND',
    } = filters;

    const params: any = {
      ...(searchTerm && { search: searchTerm }),
      ...(status_ids && { status_ids }),
      ...(location_ids && location_ids.length > 0 && { location_ids: location_ids.join(',') }),
      ...(courier_ids && { courier_ids }),
      ...(team_id && { team_id }),
      ...(sortBy && { 'sorting[column]': sortBy }),
      ...(sortDirection && { 'sorting[direction]': sortDirection }),
      page,
      per_page: limit,
    };

    // Agregar advanced filters con el formato correcto
    if (advancedFilters && advancedFilters.length > 0) {
      advancedFilters.forEach((filter, index) => {
        params[`advanced_filters[filters][${index}][column]`] = filter.column;
        params[`advanced_filters[filters][${index}][operator]`] = filter.operator;
        if (filter.value !== undefined) {
          if (Array.isArray(filter.value)) {
            filter.value.forEach((val) => {
              params[`advanced_filters[filters][${index}][value][]`] = val;
            });
          } else {
            params[`advanced_filters[filters][${index}][value]`] = filter.value;
          }
        }
      });
      params['advanced_filters[logic]'] = logic;
    }

    // Solo mostrar loading global para la primera página
    const showGlobalLoading = page === 1;
    const response = await this.httpClient.get<any>('/preparations', params, {}, showGlobalLoading);

    return {
      orderpreparation: response.data,
      nextPage: response.meta.currentPage < response.meta.lastPage ? response.meta.currentPage + 1 : undefined,
      hasMore: response.meta.currentPage < response.meta.lastPage,
      total: response.meta.total,
    };
  }

  async getAll(): Promise<OrderPreparationModel[]> {
    const response = await this.getOrderPreparationPaginated();
    return response.orderpreparation;
  }
}
